module.exports = __webpack_public_path__ + "static/media/blackPointer.c4cd5adf.svg";